import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'unspecified' },
    { value: 1, label: 'image' },
    { value: 2, label: 'file' },
    { value: 3, label: 'link' },
    { value: 4, label: 'video' },
    { value: 5, label: 'audio' },
    { value: 6, label: 'embed' },
  ],
});
